<div class="payment-icons-container">
  <div class="content">
    <img
      *ngFor="let image of lazyLoadedComponents$ | async"
      src="#"
      errorImage="./assets/ui/shared/error/not_found_error_image.png"
      [lazyLoad]="image.mediaNew.url"
      [defaultImage]="image.mediaNew.url"
      [alt]="image.mediaNew.altText"
      [title]="image.mediaNew.titleText" />
  </div>
</div>
